import workspaceQuery from 'graphql/queries/customer/CustomerBudgetProfileWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/customer/CustomerBudgetProfileListQuery.graphql';
import instanceQuery from 'graphql/queries/customer/CustomerBudgetProfileQuery.graphql';
import defaultQuery from 'graphql/queries/customer/CustomerBudgetProfileDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/CustomerBudgetProfileMutation.graphql';
import fragment from 'graphql/fragments/customer/CustomerBudgetProfileFragment.graphql';

const CustomerBudgetProfile = {
  type: 'CustomerBudgetProfile',
  title: 'Customer Budget Profiles',
  formTitle: 'Customer Budget Profile',
  formUrl: '/Customers/BudgetProfile/Details/',
  workspaceUrl: '/Customers/BudgetProfile/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'CUSTOMER_BUDGET_PROFILES',
};

export default CustomerBudgetProfile;
